import { render, staticRenderFns } from "./newPrice.vue?vue&type=template&id=3e7dbef9&scoped=true&"
import script from "./newPrice.vue?vue&type=script&lang=js&"
export * from "./newPrice.vue?vue&type=script&lang=js&"
import style0 from "./newPrice.vue?vue&type=style&index=0&id=3e7dbef9&lang=scss&scoped=true&"
import style1 from "./newPrice.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7dbef9",
  null
  
)

export default component.exports